import React from 'react'
import { useState, useEffect } from 'react';
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; 
import '../css/contact.css'
import meet from '../Images/meet.png'
import check from '../Images/check.png'
import Navbar from './Navbar'
import cntImg from "../Images/Group 2215.png"
import wtspImg from '../Images/wtspImg.png'
import { Link } from 'react-router-dom';
import Footer from './Footer';

function Contact() {
  const [selectedOption, setSelectedOption] = useState("");
  
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // Scroll positioning states
  const [topDBI, setTopDBI] = useState();
  const [topTAA, setTopTAA] = useState();
  const [topDBP, setTopDBP] = useState();
  const [topMS, setTopMS] = useState();
  const [topDA, setTopDA] = useState();

  useEffect(() => {
    const handleLoad = () => {
      const targetDiv = document.getElementById("DBI");
      const targetDiv2 = document.getElementById("TAA");
      const targetDiv3 = document.getElementById("DBP");
      const targetDiv4 = document.getElementById("MS");
      const targetDiv5 = document.getElementById("DA");

      if (targetDiv) {
        const rect = targetDiv.getBoundingClientRect();
        setTopDBI(rect.top);
      }
      if (targetDiv2) {
        const rect2 = targetDiv2.getBoundingClientRect();
        setTopTAA(rect2.top);
      }
      if (targetDiv3) {
        const rect3 = targetDiv3.getBoundingClientRect();
        setTopDBP(rect3.top);
      }
      if (targetDiv4) {
        const rect4 = targetDiv4.getBoundingClientRect();
        setTopMS(rect4.top);
      }
      if (targetDiv5) {
        const rect5 = targetDiv5.getBoundingClientRect();
        setTopDA(rect5.top);
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  const scrollToDBI = () => {
    window.scrollTo({
      top: topDBI - 100,
      behavior: "smooth",
    });
  };

  const scrollToTAA = () => {
    window.scrollTo({
      top: topTAA - 100,
      behavior: "smooth",
    });
  };

  const scrollToDBP = () => {
    window.scrollTo({
      top: topDBP - 100,
      behavior: "smooth",
    });
  };

  const scrollToMS = () => {
    window.scrollTo({
      top: topMS - 100,
      behavior: "smooth",
    });
  };

  const scrollToDA = () => {
    window.scrollTo({
      top: topDA - 100,
      behavior: "smooth",
    });
  };

  // OFFICE VISIT BOOKING FORM STATES
  const [location, setLocation] = useState('Mumbai')
  const [country, setCountry] = useState('India')
  const [dateTime, setDateTime] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [companyEmail, setCompanyEmail] = useState('')
  const [yourName, setYourName] = useState('')
  const [companyDes, setCompanyDes] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [companyAddress, setCompanyAddress] = useState('')
  const [isSubmittingVisit, setIsSubmittingVisit] = useState(false)

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
  };

  // OFFICE VISIT BOOKING HANDLER - Fixed validation issues
  const handleVisits = async(e) => {
    e.preventDefault();
    setIsSubmittingVisit(true);
    
    try {
      // Validate required fields
      if (!dateTime) {
        alert('Please select a visit date');
        setIsSubmittingVisit(false);
        return;
      }

      // Ensure date is in future
      const selectedDate = new Date(dateTime);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (selectedDate <= today) {
        alert('Please select a future date for your visit');
        setIsSubmittingVisit(false);
        return;
      }

      const formData = {
        company_name: companyName.trim(),
        your_name: yourName.trim(),
        company_designation: companyDes.trim(),
        company_email: companyEmail.trim(),
        phone_number: phoneNumber || '',
        company_address: companyAddress.trim(),
        visit_date: dateTime,
        city: location,
        country: country
      }

      console.log('Office Visit Booking Data:', formData);  
      
      const response = await fetch('http://127.0.0.1:8000/api/contact/office-visit/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      if (response.ok) {
        console.log('Success:', data);
        alert('Office visit booking submitted successfully! We will confirm your visit soon.');
        
        // Reset form
        setCompanyName('');
        setYourName('');
        setCompanyDes('');
        setCompanyEmail('');
        setPhoneNumber('');
        setCompanyAddress('');
        setDateTime('');
      } else {
        console.error('Error:', data);
        // Handle specific validation errors
        if (data.visit_date) {
          alert('Visit Date Error: ' + data.visit_date[0]);
        } else if (data.phone_number) {
          alert('Phone Number Error: ' + data.phone_number[0]);
        } else {
          alert('Error submitting booking: ' + (data.error || JSON.stringify(data)));
        }
      }
      
    } catch(error) {
      console.error('Network error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmittingVisit(false);
    }
  };

  // INVESTOR/PARTNER MEETING FORM STATES
  const [mCompanyName, setMCompanyName] = useState('')
  const [mYourName, setMYourName] = useState('')
  const [mCompanyDes, setMCompanyDes] = useState('')
  const [mCompanyEmail, setMCompanyEmail] = useState('')
  const [mPhoneNumber, setMPhoneNumber] = useState('')
  const [mGoogleMeet, setMGoogleMeet] = useState(false)
  const [meetingType, setMeetingType] = useState('investor')
  const [meetingAgenda, setMeetingAgenda] = useState('')
  const [isSubmittingMeet, setIsSubmittingMeet] = useState(false)

  const [isChecked, setChecked] = useState(false);
  const [cbStyle, setCbStyle] = useState({
    display: "none"
  });

  const handleClick = () => {
    const cb = document.getElementById('checkbox')
    const cb2 = document.getElementById('checkbox2')
      
    if(!isChecked) {
      setCbStyle({
        display: "inline-block",
        position: 'absolute',
        zIndex: '-1'
      })
      if(cb) cb.classList.add('checkTsp')
      if(cb2) cb2.classList.add('checkTsp')
      setChecked(true)
      setMGoogleMeet(true)
    } else {
      setCbStyle({
        display: "none"
      })
      setChecked(false)
      if(cb) cb.classList.remove('checkTsp')
      if(cb2) cb2.classList.remove('checkTsp')
      setMGoogleMeet(false)
    }
  };

  // INVESTOR/PARTNER MEETING HANDLER - Connected to Django Backend
  const handleMeet = async(e) => {
    e.preventDefault();
    setIsSubmittingMeet(true);
    
    try {
      const formData = {
        company_name: mCompanyName.trim(),
        your_name: mYourName.trim(),
        company_designation: mCompanyDes.trim(),
        company_email: mCompanyEmail.trim(),
        phone_number: mPhoneNumber || '',
        meeting_type: meetingType,
        connect_google_meet: mGoogleMeet,
        meeting_agenda: meetingAgenda.trim()
      }

      console.log('Meeting Request Data:', formData);  
      
      const response = await fetch('http://127.0.0.1:8000/api/contact/investor-meeting/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      if (response.ok) {
        console.log('Success:', data);
        alert('Meeting request submitted successfully! Our team will contact you soon.');
        
        // Reset form
        setMCompanyName('');
        setMYourName('');
        setMCompanyDes('');
        setMCompanyEmail('');
        setMPhoneNumber('');
        setMeetingAgenda('');
        setChecked(false);
        setMGoogleMeet(false);
        setCbStyle({ display: "none" });
      } else {
        console.error('Error:', data);
        alert('Error submitting meeting request: ' + (data.error || JSON.stringify(data)));
      }
      
    } catch(error) {
      console.error('Network error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmittingMeet(false);
    }
  };

  // SERVICE QUOTE FORM STATES
  const [service, setService] = useState('')
  const [solution, setSolution] = useState('')
  const [qCompanyName, setQCompanyName] = useState('')
  const [qYourName, setQYourName] = useState('')
  const [qCompanyDes, setQCompanyDes] = useState('')
  const [qCompanyEmail, setQCompanyEmail] = useState('')
  const [qPhoneNumber, setQPhoneNumber] = useState('')
  const [qAdditionalBrief, setQAdditionalBrief] = useState('')
  const [qGoogleMeet, setQGoogleMeet] = useState(false)
  const [isSubmittingQuote, setIsSubmittingQuote] = useState(false)

  const [isChecked2, setChecked2] = useState(false);
  const [cbStyle2, setCbStyle2] = useState({
    display: "none"
  });

  const handleClick2 = () => {
    const cb = document.getElementById('checkbox3')
    const cb2 = document.getElementById('checkbox4')
      
    if(!isChecked2) {
      setCbStyle2({
        display: "inline-block",
        position: 'absolute',
        zIndex: '-1'
      })
      if(cb) cb.classList.add('checkTsp')
      if(cb2) cb2.classList.add('checkTsp')
      setChecked2(true)
      setQGoogleMeet(true)
    } else {
      setCbStyle2({
        display: "none"
      })
      setChecked2(false)
      if(cb) cb.classList.remove('checkTsp')
      if(cb2) cb2.classList.remove('checkTsp')
      setQGoogleMeet(false)
    }
  };

  // SERVICE QUOTE HANDLER - Fixed validation issues
  const handleQuote = async(e) => {
    e.preventDefault();
    setIsSubmittingQuote(true);
    
    try {  
      // Validate additional brief minimum length (backend requires 20+ characters)
      if (qAdditionalBrief.trim().length < 20) {
        alert('Please provide a more detailed description (at least 20 characters)');
        setIsSubmittingQuote(false);
        return;
      }

      const formData = {
        company_name: qCompanyName.trim(),
        your_name: qYourName.trim(),
        company_designation: qCompanyDes.trim(),
        company_email: qCompanyEmail.trim(),
        phone_number: qPhoneNumber || '',
        selected_service: service,
        selected_solution: solution,
        additional_brief: qAdditionalBrief.trim(),
        connect_google_meet: qGoogleMeet
      }

      console.log('Service Quote Data:', formData);  
      
      const response = await fetch('http://127.0.0.1:8000/api/contact/service-quote/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      if (response.ok) {
        console.log('Success:', data);
        alert('Service quote request submitted successfully! We will send you a detailed quote within 24-48 hours.');
        
        // Reset form
        setService('');
        setSolution('');
        setQCompanyName('');
        setQYourName('');
        setQCompanyDes('');
        setQCompanyEmail('');
        setQPhoneNumber('');
        setQAdditionalBrief('');
        setChecked2(false);
        setQGoogleMeet(false);
        setCbStyle2({ display: "none" });
      } else {
        console.error('Error:', data);
        // Handle specific validation errors
        if (data.additional_brief) {
          alert('Brief Error: ' + data.additional_brief[0]);
        } else if (data.phone_number) {
          alert('Phone Number Error: ' + data.phone_number[0]);
        } else {
          alert('Error submitting quote request: ' + (data.error || JSON.stringify(data)));
        }
      }
      
    } catch(error) {
      console.error('Network error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmittingQuote(false);
    }
  };

  const openWhatsApp = () => {
    const phoneNumber = '7038887201';
    const message = 'Hello, I would like to contact you';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="wwc">
      <Navbar page="cont"/>
      <div className='contact'>
        <img src={cntImg} alt="cntImg" className='cntImg' />
        <div className="contHead">
          <div className="sc">
            <h1>STAY CONNECTED</h1>
            <span className='scWhite'></span><div className="scun"></div>
          </div>
          <div className="wtsp">
            <h1>WE ARE AVAILABLE FOR CHAT, VIRTUALLY 24*7</h1>
            <button onClick={openWhatsApp} >CHAT WITH US <img src={wtspImg} alt="wtspImg" className='wtspImg'/></button>
          </div>
          <h1>MORE WAYS TO CONNECT</h1>
          <div className="all-feats">
            <div className="af" onClick={scrollToDBI}>
              <div className="whiteGlow"></div>
              <p className='afp'>OFFLINE MEET</p>
            </div>
            <div className="af" onClick={scrollToTAA} >
              <div className="whiteGlow"></div>
              <p className='afp'>GET A QUOTE</p>
            </div>
            <div className="af" onClick={scrollToDBP}>
              <div className="whiteGlow"></div>
              <p className='afp'>INVESTORS / PARTNERS</p>
            </div>
            <div className="af" onClick={scrollToMS}>
              <div className="whiteGlow"></div>
              <p className='afp'>CAREERS</p>
            </div>
            <div className="af" onClick={scrollToDA}>
              <div className="whiteGlow"></div>
              <p className='afp'>HELP & SUPPORT</p>
            </div>
          </div>
        </div>

        <div className="allWays">
          {/* OFFICE VISIT BOOKING FORM */}
          <div className="aw" id='DBI'>
            <div className="oro">
              <h1>OUR REGISTERED OFFICE</h1>
              <p>Shop 8, Shreeji Enclave CHS, Sector 13, Kharghar, Navi Mumbai.</p>
              <p>Book our visit :</p>
            </div>
            <form className='contact-form oro-form' onSubmit={handleVisits}>
              <div className="c1">
                <select value={location} onChange={handleLocationChange} required>
                  <option value="Mumbai">Mumbai</option>
                  <option value="Navi Mumbai">Navi Mumbai</option>
                  <option value="Thane">Thane</option>
                  <option value="Pune">Pune</option>
                </select>
                <select value={country} onChange={handleCountryChange} required>
                  <option value="India">India</option>
                </select>
                <input 
                  type="date" 
                  className='dateTime' 
                  value={dateTime}
                  onChange={(e) => setDateTime(e.target.value)}
                  min={new Date().toISOString().split('T')[0]}
                  required
                />
              </div>
              <div className="c2">
                <input 
                  type="text" 
                  className='cn' 
                  placeholder='Company Name' 
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                />
                <input 
                  type="text" 
                  className='yn' 
                  placeholder='Your Name' 
                  value={yourName}
                  onChange={(e) => setYourName(e.target.value)}
                  required
                />
              </div>
              <div className="c3">
                <input 
                  type="text" 
                  className='cd' 
                  placeholder='Company Designation' 
                  value={companyDes}
                  onChange={(e) => setCompanyDes(e.target.value)}
                  required
                />
                <input 
                  type="email" 
                  className='cd' 
                  placeholder='Company Email' 
                  value={companyEmail}
                  onChange={(e) => setCompanyEmail(e.target.value)}
                  required
                />
                <div className="phn">
                  <PhoneInput
                    placeholder="Phone Number"
                    value={phoneNumber}
                    onChange={setPhoneNumber}
                    required
                  />
                </div>
              </div>
              <textarea 
                name="company_address" 
                cols="30" 
                rows="10" 
                placeholder='Company Address' 
                value={companyAddress}
                onChange={(e) => setCompanyAddress(e.target.value)}
                required
              />
              <div className="oro-yellow">**We will confirm our availability to you through Email and WhatsApp</div>
              
              <div className="gaq-btn">
                <button type="submit" className='gaq' disabled={isSubmittingVisit}>
                  {isSubmittingVisit ? 'SUBMITTING...' : 'CONFIRM BOOKING'}
                </button>
              </div>
            </form>
          </div>

          {/* INVESTOR/PARTNER MEETING FORM */}
          <div className="aw" id='TAA'>
            <h1>FOR INVESTORS AND PARTNERS</h1>
            <form className='contact-form' onSubmit={handleMeet}>
              <div className="c1">
                <select value={meetingType} onChange={(e) => setMeetingType(e.target.value)} required>
                  <option value="investor">Investment Opportunity</option>
                  <option value="partner">Partnership Discussion</option>
                  <option value="strategic">Strategic Alliance</option>
                  <option value="collaboration">Collaboration</option>
                  <option value="acquisition">Acquisition Discussion</option>
                  <option value="joint_venture">Joint Venture</option>
                </select>
              </div>
              <div className="c2">
                <input 
                  type="text" 
                  className='cn' 
                  placeholder='Company Name' 
                  value={mCompanyName}
                  onChange={(e) => setMCompanyName(e.target.value)}
                  required
                />
                <input 
                  type="text" 
                  className='yn' 
                  placeholder='Your Name' 
                  value={mYourName}
                  onChange={(e) => setMYourName(e.target.value)}
                  required
                />
              </div>
              <div className="c3">
                <input 
                  type="text" 
                  className='cd' 
                  placeholder='Company Designation' 
                  value={mCompanyDes}
                  onChange={(e) => setMCompanyDes(e.target.value)}
                  required
                />
                <input 
                  type="email" 
                  className='cd' 
                  placeholder='Company Email' 
                  value={mCompanyEmail}
                  onChange={(e) => setMCompanyEmail(e.target.value)}
                  required
                />
                <div className="phn">
                  <PhoneInput
                    placeholder="Phone Number"
                    value={mPhoneNumber}
                    onChange={setMPhoneNumber}
                    required
                  />
                </div>
              </div>
              <textarea 
                placeholder='Meeting Agenda (Optional)' 
                value={meetingAgenda}
                onChange={(e) => setMeetingAgenda(e.target.value)}
                rows="4"
              />
              <div className="meetCheck">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => {}}
                />
                <span 
                  className='checkbox'
                  onClick={handleClick}
                  id='checkbox'
                ></span>
                <img src={check} alt="check" className='checkbox' style={cbStyle}/>
                <label htmlFor="nothing">CONNECT USING GOOGLE MEET <img src={meet} alt="meet" /></label>
              </div>
              <div className="gaq-btn">
                <button type="submit" className='gaq' disabled={isSubmittingMeet}>
                  {isSubmittingMeet ? 'SUBMITTING...' : 'CONFIRM MEETING'}
                </button>
              </div>
            </form>
          </div>

          {/* SERVICE QUOTE FORM */}
          <div className="aw" id='DBP'>
            <h1>GET A QUOTE</h1>
            <form className='contact-form' onSubmit={handleQuote}>
              <div className="c1">
                <select value={service} onChange={(e) => setService(e.target.value)} required>
                  <option value="">SELECT SERVICE</option>
                  <option value="strategy">Strategy Consulting</option>
                  <option value="graphic_design">Graphic Design</option>
                  <option value="website_development">Website Development</option>
                  <option value="motion_video">Motion & Video</option>
                  <option value="social_media">Social Media Management</option>
                  <option value="app_development">App Development</option>
                  <option value="sound_design">Sound Design</option>
                  <option value="ai_ar_vr">AI, AR & VR Solutions</option>
                </select>
                <select value={solution} onChange={(e) => setSolution(e.target.value)} required>
                  <option value="">SELECT SOLUTION</option>
                  <option value="custom_development">Custom Development</option>
                  <option value="template_based">Template-Based Solution</option>
                  <option value="consulting_only">Consulting Only</option>
                  <option value="full_service">Full-Service Package</option>
                  <option value="maintenance">Maintenance & Support</option>
                  <option value="optimization">Performance Optimization</option>
                  <option value="integration">System Integration</option>
                  <option value="training">Training & Workshops</option>
                </select> 
              </div>
              <div className="c2">
                <input 
                  type="text" 
                  className='cn' 
                  placeholder='Company Name' 
                  value={qCompanyName}
                  onChange={(e) => setQCompanyName(e.target.value)}
                  required
                />
                <input 
                  type="text" 
                  className='yn' 
                  placeholder='Your Name' 
                  value={qYourName}
                  onChange={(e) => setQYourName(e.target.value)}
                  required
                />
              </div>
              <div className="c3">
                <input 
                  type="text" 
                  className='cd' 
                  placeholder='Company Designation' 
                  value={qCompanyDes}
                  onChange={(e) => setQCompanyDes(e.target.value)}
                  required
                />
                <input 
                  type="email" 
                  className='cd' 
                  placeholder='Company Email' 
                  value={qCompanyEmail}
                  onChange={(e) => setQCompanyEmail(e.target.value)}
                  required
                />
                <div className="phn">
                  <PhoneInput
                    placeholder="Phone Number"
                    value={qPhoneNumber}
                    onChange={setQPhoneNumber}
                    required
                  />
                </div>
              </div>
              <textarea 
                name="additional_brief" 
                cols="30" 
                rows="10" 
                placeholder='Additional Brief (Please provide detailed requirements - minimum 20 characters)' 
                value={qAdditionalBrief}
                onChange={(e) => setQAdditionalBrief(e.target.value)}
                required
                minLength={20}
              />
              <div className="meetCheck">
                <input
                  type="checkbox"
                  checked={isChecked2}
                  onChange={() => {}}
                />
                <span 
                  className='checkbox'
                  onClick={handleClick2}
                  id='checkbox3'
                ></span>
                <img src={check} alt="check" className='checkbox' style={cbStyle2}/>
                <label htmlFor="nothing">CONNECT USING GOOGLE MEET <img src={meet} alt="meet" /></label>
              </div>
              <div className="gaq-btn">
                <button type="submit" className='gaq' disabled={isSubmittingQuote}>
                  {isSubmittingQuote ? 'SUBMITTING...' : 'GET A QUOTE'}
                </button>
              </div>
            </form>
          </div>

          {/* CAREERS SECTION */}
          <div className="aw" id='MS'>
            <h1 className='aw-careers'>CAREERS</h1>
            <p className='caw'>Send your resume at <a href='mailto:hr@redfibre.co'>hr@redfibre.co</a></p>
          </div>

          {/* PROJECTS SECTION */}
          <div className="aw">
            <h1 className='aw-careers'>PROJECTS</h1>
            <p className='caw'>Send your projects at <a href='mailto:project@redfibre.co'>project@redfibre.co</a></p>
          </div>

          {/* HELP & SUPPORT SECTION */}
          <div className="aw" id='DA'>
            <h1 className='aw-careers'>HELP & SUPPORT</h1>
            <div className="wtsp">
              <button onClick={openWhatsApp}>CHAT WITH US <img src={wtspImg} alt="wtspImg" className='wtspImg'/></button>
            </div>
            <p className='caw'>Or send your query at <a href='mailto:redfibre7@gmail.com'>redfibre7@gmail.com</a></p>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default Contact